import {BaseConverter} from '../../base/converters/base-converter.converter';
import {UnitPropertiesModel} from '../models/unit-properties.model';
import {UnitProperties} from '../DTO/unitProperties';
import {Injectable} from '@angular/core';

@Injectable()
export class UnitPropertiesConverter extends BaseConverter<UnitPropertiesModel, UnitProperties> {
  convertToDto(model: UnitPropertiesModel): UnitProperties {
    if (!model) {
      return;
    }
    return {
      LANGUAGE: model.language,
      CERTIFICATE_DNQ_FORMAT: model.certificateDnqFormat,
      IPPFE_ASSISTANCE_LINK: model.ippFeAssistanceLink,
      PRIVACY_POLICY_TENANT: model.privacyPolicyTenant,
      COUNTRY: model.country,
      PRIVACY_POLICY_URL: model.privacyPolicyURL,
      PRIVACY_POLICY_TEMPLATE: model.privacyPolicyTemplate,
      IPP_IDENTIFICATION_TYPES: model == null ? null : model.identificationTypes.join(';'),
      RAO_NUMBER: model.raoNumber
    };
  }

  convertToModel(dto: UnitProperties): UnitPropertiesModel {
    if (!dto) {
      return;
    }
    let model: UnitPropertiesModel = new UnitPropertiesModel();
    model.language = dto.LANGUAGE;
    model.certificateDnqFormat = dto.CERTIFICATE_DNQ_FORMAT;
    model.ippFeAssistanceLink = dto.IPPFE_ASSISTANCE_LINK;
    model.privacyPolicyURL = dto.PRIVACY_POLICY_URL;
    model.privacyPolicyTenant = dto.PRIVACY_POLICY_TENANT;
    model.privacyPolicyTemplate = dto.PRIVACY_POLICY_TEMPLATE;
    model.country = dto.COUNTRY;
    model.identificationTypes = dto.IPP_IDENTIFICATION_TYPES == null ? null : dto.IPP_IDENTIFICATION_TYPES.split(';').filter(i => i);
    model.raoNumber = dto.RAO_NUMBER;
    return model;
  }

}
